import { __assign, __extends } from "tslib";
import React from 'react';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { shorthand } from '../utils/css-utils';
import { GenericImage } from './generic-image';
var SectionImage = /** @class */ (function (_super) {
    __extends(SectionImage, _super);
    function SectionImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionImage.prototype.render = function () {
        var _a = this.props, section = _a.section, cssClass = _a.cssClass, columnCssClass = _a.columnCssClass;
        var imageProps = section.link ? { href: section.link } : {};
        var innerPadding = section.innerPadding, outerPadding = section.outerPadding;
        return (React.createElement(WrapperItem, null,
            React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(outerPadding) },
                React.createElement(Column, { padding: shorthand(innerPadding), cssClass: columnCssClass },
                    React.createElement(GenericImage, __assign({ src: section.src, width: section.width, probableWidth: section.probableWidth, probableHeight: section.probableHeight }, imageProps, { alt: "", imgStyle: section.imgStyle, showAfterLoad: true }))))));
    };
    return SectionImage;
}(React.Component));
export { SectionImage };
//# sourceMappingURL=section-image.js.map